import 'components/text/text.scss';



// WEBPACK FOOTER //
// ./resources/components/text/index.js